import { render, staticRenderFns } from "./EquipmentSubcategoriesForm.vue?vue&type=template&id=a6d4fabe"
import script from "./EquipmentSubcategoriesForm.vue?vue&type=script&lang=js"
export * from "./EquipmentSubcategoriesForm.vue?vue&type=script&lang=js"
import style0 from "./EquipmentSubcategoriesForm.vue?vue&type=style&index=0&id=a6d4fabe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports